import React, { useMemo } from "react";
import { Form, FormField, PrimaryButton } from "common/Forms";
import { TextInput, TextAreaInput, SelectInput, IntegerInput } from "common/Forms/inputs";
import { Grid, GridCell } from "common/Grid/Grid";
import { toast } from "react-toastify";
import { validationRuleFactory } from "common/Forms/validation";

const businessCategories = [
  { value: "food-and-drink", label: "Food and Drink" },
  { value: "other", label: "Other" },
];

const businessType = [
  { value: "self-employed-person-sole-trader", label: "Self-employed person / sole trader" },
  { value: "private-company-pty-ltd", label: "Private Company (Pty) Ltd" },
  { value: "partnership-many-co-owners", label: "Partnership / many co-owners" },
  { value: "close-corporation-cc", label: "Close Corporation (CC)" },
  { value: "non-profit-organisation", label: "Non-Profit Organisation" },
  { value: "non-profit-company", label: "Non-Profit Company" },
  { value: "trust", label: "Trust" },
];


// const packages = [
//   { value: "freemium-excludes-mobile-apps", label: "Freemium (Excludes mobile apps)" },
//   { value: "professional-subscription-required", label: "Professional (Subscription Required)" },
//   { value: "enterprise", label: "Enterprise" },
// ];

const subCategoryOptions = [
  { value: "bakery", label: "Bakery" },
  { value: "bar-and-club", label: "Bar and club" },
  { value: "cafe", label: "Cafe" },
  { value: "catering", label: "Catering" },
  { value: "food-market-truck", label: "Food market/truck" },
  { value: "restaurant", label: "Restaturant" },
  { value: "wine-brewery-or-distillery", label: "Wine, brewery or distillery" },
  { value: "package-stores-beer-wine-and-liquor", label: "Package Stores - Beer, Wine and Liquor" },
  { value: "other-food-and-drink", label: "Other Food and Drink" },
  { value: "not-in-the-food-and-beverage-industry", label: "Not in the food and beverage industry" },
];

const textInputBoxClass = ["text_input_box"];

export const MainForm = ({ userInput, setUserInput, setValidationResult }) => {
  const emailValidationRules = useMemo(() => [validationRuleFactory.required("email can't be empty"), validationRuleFactory.emailValidation('please enter a valid email address')], []);

  const onValidationWrapper = (fieldName, onValidation) => {
    return (isValid, failedResults) => {
      setValidationResult(prev => ({ ...prev, [fieldName]: isValid }));
      onValidation(isValid, failedResults);
    };
  };

  return (
    <Form>
      <Grid columns={2}>
        <GridCell>
          <FormField
            label="Logo (png format)"
            id="logoUrlFile"
            inputFactory={(id, name) => (
              <div className="min-h-[150px] flex flex-col items-center justify-center border-2 border-dashed border-[#ccc] rounded-[8px] p-[20px] text-center relative mt-2">
                <input
                  type="file"
                  name={name}
                  id={id}
                  accept=".png"
                  className="hidden"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      const fileName = file.name.toLowerCase();
                      if (!fileName.endsWith(".png")) {
                        toast.warn("Logo only accepts .png format");
                        e.target.value = "";
                        return;
                      }
                      const reader = new FileReader();
                      reader.onload = (ev) => {
                        setUserInput((prev) => ({
                          ...prev,
                          logoUrl: ev.target.result,
                        }));
                      };
                      reader.readAsDataURL(file);
                    }
                  }}
                />

                {userInput?.logoUrl ? (
                  <div className="relative inline-block">
                    <img
                      src={userInput?.logoUrl}
                      alt="Preview"
                      className="max-w-[150px] max-h-[80px] block"
                    />
                    <button
                      type="button"
                      onClick={() =>
                        setUserInput((prev) => ({ ...prev, logoUrl: "" }))
                      }
                      className="absolute -top-[10px] -right-[10px] bg-[#ff4444] text-white border-none rounded-full w-[24px] h-[24px] cursor-pointer text-[14px] leading-[1] flex items-center justify-center"
                    >
                      ×
                    </button>
                  </div>
                ) : (
                  <PrimaryButton
                    classNames={["min-w-[130px]"]}
                    action={() =>
                      document.getElementById("logoUrlFile").click()
                    }
                  >
                    Browse
                  </PrimaryButton>
                )}

                <div className="text-[13px] text-[#999] mt-[8px]">
                  Recommended: 150 x 80 px
                </div>
              </div>
            )}
          />
        </GridCell>
        <GridCell>
          <FormField
            label="Favicon (.ico format)"
            id="faviconFile"
            inputFactory={(id, name) => (
              <div className="min-h-[150px] flex flex-col items-center justify-center border-2 border-dashed border-[#ccc] rounded-[8px] p-[20px] text-center relative mt-2">
                <input
                  type="file"
                  name={name}
                  id={id}
                  accept=".ico"
                  className="hidden"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      const fileName = file.name.toLowerCase();
                      if (!fileName.endsWith(".ico")) {
                        toast.warn("Favicon only accepts .ico format");
                        e.target.value = "";
                        return;
                      }
                      const reader = new FileReader();
                      reader.onload = (ev) => {
                        setUserInput((prev) => ({
                          ...prev,
                          favicon: ev.target.result,
                        }));
                      };
                      reader.readAsDataURL(file);
                    }
                  }}
                />

                {userInput?.favicon ? (
                  <div className="relative inline-block">
                    <img
                      src={userInput?.favicon}
                      alt="Preview"
                      className="max-w-[150px] max-h-[80px] block"
                    />
                    <button
                      type="button"
                      onClick={() =>
                        setUserInput((prev) => ({ ...prev, favicon: "" }))
                      }
                      className="absolute -top-[10px] -right-[10px] bg-[#ff4444] text-white border-none rounded-full w-[24px] h-[24px] cursor-pointer text-[14px] leading-[1] flex items-center justify-center"
                    >
                      ×
                    </button>
                  </div>
                ) : (
                  <PrimaryButton
                    classNames={["min-w-[130px]"]}
                    action={() => document.getElementById("faviconFile").click()}
                  >
                    Browse
                  </PrimaryButton>
                )}
              </div>
            )}
          />
        </GridCell>
        <GridCell>
          <FormField
            label="Name"
            id="name"
            required={true}
            classNames={textInputBoxClass}
            inputFactory={(id, name, onValidation) => (
              <TextInput
                id={id}
                name={name}
                value={userInput.name}
                onChange={(_, v) => setUserInput({ ...userInput, name: v })}
                onValidation={onValidation}
              />
            )}
          />
        </GridCell>
        <GridCell>
          <FormField
            label="Surname"
            id="surname"
            classNames={textInputBoxClass}
            inputFactory={(id, name, onValidation) => (
              <TextInput
                id={id}
                name={name}
                value={userInput.surname}
                onChange={(_, v) => setUserInput({ ...userInput, surname: v })}
                onValidation={onValidation}
              />
            )}
          />
        </GridCell>
        <GridCell>
          <FormField
            label="Business Mobile Number"
            id="businessMobileNumber"
            classNames={textInputBoxClass}
            inputFactory={(id, name, onValidation) => (
              <IntegerInput
                id={id}
                name={name}
                value={userInput.businessMobileNumber}
                onChange={(_, v) =>
                  setUserInput({ ...userInput, businessMobileNumber: v })
                }
                onValidation={onValidation}
              />
            )}
          />
        </GridCell>
        <GridCell>
          <FormField
            label="Business Email"
            id="businessEmail"
            classNames={textInputBoxClass}
            inputFactory={(id, name, onValidation) => (
              <TextInput
                id={id}
                name={name}
                value={userInput.businessEmail}
                onChange={(_, v) =>
                  setUserInput({ ...userInput, businessEmail: v })
                }
                onValidation={onValidationWrapper(id, onValidation)}
                validationRules={emailValidationRules}
                skipInitialValidation={true}
              />
            )}
          />
        </GridCell>
        <GridCell>
          <FormField
            label="Business Trading Name"
            id="businessTradingName"
            classNames={textInputBoxClass}
            inputFactory={(id, name, onValidation) => (
              <TextInput
                id={id}
                name={name}
                value={userInput.businessTradingName}
                onChange={(_, v) =>
                  setUserInput({ ...userInput, businessTradingName: v })
                }
                onValidation={onValidation}
              />
            )}
          />
        </GridCell>
        <GridCell>
          <FormField
            label="Business Trading Location"
            id="businessTradingLocation"
            classNames={textInputBoxClass}
            inputFactory={(id, name, onValidation) => (
              <TextAreaInput
                id={id}
                name={name}
                value={userInput.businessTradingLocation}
                onChange={(_, v) =>
                  setUserInput({ ...userInput, businessTradingLocation: v })
                }
                onValidation={onValidation}
              />
            )}
          />
        </GridCell>
        <GridCell>
          <FormField
            label="Business Type"
            id="businessType"
            classNames={textInputBoxClass}
            inputFactory={(id, name, onValidation) => (
              <SelectInput
                id={id}
                name={name}
                selectedKey={userInput.businessType}
                optionProvider={() => businessType}
                keySelector={(x) => x.value}
                labelSelector={(x) => x.label}
                onChange={(_, v) =>
                  setUserInput({ ...userInput, businessType: v?.value })
                }
                onValidation={onValidation}
              />
            )}
          />
        </GridCell>
        <GridCell>
          <FormField
            label="Select Your Business Category"
            id="businessCategory"
            inputFactory={(id, name, onValidation) => (
              <SelectInput
                id={id}
                name={name}
                selectedKey={userInput.businessCategory}
                optionProvider={() => businessCategories}
                keySelector={(x) => x.value}
                labelSelector={(x) => x.label}
                onChange={(_, v) =>
                  setUserInput({ ...userInput, businessCategory: v?.value })
                }
                onValidation={onValidation}
              />
            )}
          />
        </GridCell>
        <GridCell>
          <FormField
            label="Select Your Business Subcategory"
            id="businessSubcategory"
            inputFactory={(id, name, onValidation) => (
              <SelectInput
                id={id}
                name={name}
                selectedKey={userInput.businessSubcategory}
                optionProvider={() => subCategoryOptions}
                keySelector={(x) => x.value}
                labelSelector={(x) => x.label}
                onChange={(_, v) =>
                  setUserInput({ ...userInput, businessSubcategory: v?.value })
                }
                onValidation={onValidation}
              />
            )}
          />
        </GridCell>
        <GridCell>
          <FormField
            label="Website"
            id="website"
            inputFactory={(id, name, onValidation) => (
              <TextInput
                id={id}
                name={name}
                value={userInput.website}
                onChange={(_, v) =>
                  setUserInput({ ...userInput, website: v })
                }
                onValidation={onValidation}
              />
            )}
          />
        </GridCell>
        <GridCell>
          <FormField
            label="Bank Name"
            id="bankName"
            classNames={textInputBoxClass}
            inputFactory={(id, name, onValidation) => (
              <TextInput
                id={id}
                name={name}
                value={userInput.bankName}
                onChange={(_, v) => setUserInput({ ...userInput, bankName: v })}
                onValidation={onValidation}
              />
            )}
          />
        </GridCell>
        <GridCell>
          <FormField
            label="Account Number"
            id="accountNumber"
            classNames={textInputBoxClass}
            inputFactory={(id, name, onValidation) => (
              <IntegerInput
                id={id}
                name={name}
                type={"number"}
                value={userInput.accountNumber}
                onChange={(_, v) =>
                  setUserInput({ ...userInput, accountNumber: v })
                }
                onValidation={onValidation}
              />
            )}
          />
        </GridCell>
        <GridCell>
          <FormField
            label="Instagram Profile"
            id="instagramProfile"
            classNames={textInputBoxClass}
            inputFactory={(id, name, onValidation) => (
              <TextInput
                id={id}
                name={name}
                value={userInput.instagramProfile}
                onChange={(_, v) =>
                  setUserInput({ ...userInput, instagramProfile: v })
                }
                onValidation={onValidation}
              />
            )}
          />
        </GridCell>
        <GridCell>
          <FormField
            label="Facebook Profile"
            id="facebookProfile"
            classNames={textInputBoxClass}
            inputFactory={(id, name, onValidation) => (
              <TextInput
                id={id}
                name={name}
                value={userInput.facebookProfile}
                onChange={(_, v) =>
                  setUserInput({ ...userInput, facebookProfile: v })
                }
                onValidation={onValidation}
              />
            )}
          />
        </GridCell>
        <GridCell>
          <FormField
            label="Main Color"
            id="mainColor"
            classNames={textInputBoxClass}
            inputFactory={(id, name, onValidation) => (
              <TextInput
                id={id}
                name={name}
                value={userInput.mainColor}
                onChange={(_, v) =>
                  setUserInput({ ...userInput, mainColor: v })
                }
                onValidation={onValidation}
              />
            )}
          />
        </GridCell>
        <GridCell>
          <FormField
            label="Secondary Color"
            id="secondaryColor"
            classNames={textInputBoxClass}
            inputFactory={(id, name, onValidation) => (
              <TextInput
                id={id}
                name={name}
                value={userInput.secondaryColor}
                onChange={(_, v) =>
                  setUserInput({ ...userInput, secondaryColor: v })
                }
                onValidation={onValidation}
              />
            )}
          />
        </GridCell>
      </Grid>
    </Form>
  );
};
